import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Gauge: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm12 14 4-4' }],
    ['path', { d: 'M3.34 19a10 10 0 1 1 17.32 0' }],
  ],
];

export default Gauge;
